var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"home"},[_c('h1',[_vm._v(" just wait"),_c('br'),_vm._v(_vm._s(this.msg)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }